import React from "react";
import { Route, Routes } from "react-router-dom";
import style from "css/device.module.css";
import NotFound from "pages/common/notFound";
import NeatMain from "./neatMain";
import "css/ant.css";
import Bar from "components/device/neat/bar";
import Bar2 from "components/device/neat/bar2";
import BarPro from "components/device/neat/barPro";
import Board50 from "components/device/neat/board50";
import BoardPro from "components/device/neat/boardPro";
import Frame from "components/device/neat/frame";
import Center from "components/device/neat/center";
import Pad from "components/device/neat/pad";

function Neat() {
  return (
    <div className={style.device_popup_wrapper} style={{ marginTop: "65px" }}>
      <Routes>
        <Route path="" element={<NeatMain />} />
        <Route path="bar" element={<Bar />} />
        <Route path="bar2" element={<Bar2 />} />
        <Route path="barPro" element={<BarPro />} />
        <Route path="board50" element={<Board50 />} />
        <Route path="boardPro" element={<BoardPro />} />
        <Route path="frame" element={<Frame />} />
        <Route path="center" element={<Center />} />
        <Route path="pad" element={<Pad />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default Neat;
